import { DEFAULT_LAYOUT } from '../base';
import { AppRouteRecordRaw } from '../types';

const USER: AppRouteRecordRaw = {
    path: '/forms',
    name: 'forms',
    component: DEFAULT_LAYOUT,
    meta: {
        locale: 'menu.forms',
        icon: 'icon-storage',
        requiresAuth: true,
        order: 1,
    },
    children: [
        {
            path: '/team',
            name: 'team-management',
            component: () => import('@/views/forms/team/index.vue'),
            meta: {
                locale: 'team.management',
                requiresAuth: true,
                roles: ['*'],
            },
        },
        {
            path: '/order',
            name: 'order-management',
            component: () => import('@/views/forms/order/index.vue'),
            meta: {
                locale: 'order.management',
                requiresAuth: true,
                roles: ['*'],
            },
        },
        {
            path: '/recharge',
            name: 'recharge-records-management',
            component: () => import('@/views/forms/recharge/index.vue'),
            meta: {
                locale: 'recharge.management',
                requiresAuth: true,
                roles: ['*'],
            },
        },
    ],
};

export default USER;
